import React, { createContext, ReactNode, useContext, useEffect, useState } from "react";

interface PermissionsContextType {
  apiKey: string;
  setApiKey: (apiKey: string) => void;
  companyId: number | null;
}

const PermissionsContext = createContext<PermissionsContextType | undefined>(undefined);

export const usePermissions = () => {
  const context = useContext(PermissionsContext);
  if (context === undefined) {
    throw new Error("usePermissions must be used within a PermissionsProvider");
  }
  return context;
};

export const PermissionsProvider: React.FC<{ children: ReactNode, apiKey: string, companyId: number | null }> = ({ children, apiKey, companyId }) => {
  const [key, setKey] = useState<string>(apiKey);
  useEffect(() => {
    if (apiKey) {
      setKey(apiKey);
    }
  }, [apiKey]);
  return (
    <PermissionsContext.Provider value={{ apiKey: key, setApiKey: setKey, companyId }}>
      {children}
    </PermissionsContext.Provider>
  );
};
